export default "__VITE_ASSET__CwFeUO7g__"